import React,{useMemo}from'react';
import * as FiIcons from'react-icons/fi';
import SafeIcon from'../common/SafeIcon';
import{
  getDuplicateMusicRequestIds,
  removeDuplicateMusicRequests
}from'../utils/musicRequests';
import'./music-manager.css';

const{
  FiAlertTriangle,
  FiLink,
  FiMusic,
  FiPlus,
  FiTrash2
}=FiIcons;

const priorities=[
  'Must Play',
  'Preferred',
  'If Possible',
  'Only By Request',
  'Do Not Play'
];

function MusicManager({
  songs,
  setSongs,
  playlists,
  setPlaylists,
  questions=[]
}){
  const duplicateIds=useMemo(
    ()=>getDuplicateMusicRequestIds(songs),
    [songs]
  );

  const duplicateCount=duplicateIds.size;

  const songQuestion=questions.find(
    (question)=>question.id==='songRequestsTable'
  );

  const playlistQuestion=questions.find(
    (question)=>question.id==='playlistLinks'
  );

  const showSongRequests=songQuestion?.visible!==false;
  const showPlaylistLinks=playlistQuestion?.visible!==false;

  const updateSong=(id,key,value)=>{
    setSongs((items)=>items.map((item)=>(
      item.id===id
        ?{...item,[key]:value}
        :item
    )));
  };

  const addSong=()=>{
    setSongs((items)=>[
      ...items,
      {
        id:Date.now(),
        title:'',
        artist:'',
        priority:'Must Play',
        notes:''
      }
    ]);
  };

  const removeSong=(id)=>{
    setSongs((items)=>items.filter((item)=>item.id!==id));
  };

  const removeDuplicates=()=>{
    setSongs((items)=>removeDuplicateMusicRequests(items));
  };

  const updatePlaylist=(index,value)=>{
    setPlaylists((items)=>items.map((item,itemIndex)=>(
      itemIndex===index
        ?{...item,url:value}
        :item
    )));
  };

  return <div className="music-manager">
    {showSongRequests&&<section>
      <div className="subsection-heading">
        <span><SafeIcon icon={FiMusic}/></span>
        <div>
          <h3>{songQuestion?.title||'Song requests'}</h3>
          <p>
            Organize must-play,preferred,and do-not-play songs.
          </p>
        </div>
      </div>

      <div className="music-request-toolbar">
        <span className={duplicateCount?'has-duplicates':''}>
          {duplicateCount
            ?`${duplicateCount} duplicate ${
              duplicateCount===1?'request':'requests'
            }`
            :'No duplicate requests'}
        </span>

        {duplicateCount>0&&<button
          type="button"
          className="button secondary"
          onClick={removeDuplicates}
        >
          Remove duplicates
        </button>}
      </div>

      {duplicateCount>0&&<div
        className="music-duplicate-alert"
        role="status"
      >
        <SafeIcon icon={FiAlertTriangle}/>
        <span>
          Duplicate requests are highlighted below. Matching is
          case-insensitive and ignores punctuation.
        </span>
      </div>}

      <div className="song-table-wrap">
        <table className="song-table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Song title</th>
              <th scope="col">Artist</th>
              <th scope="col">Priority</th>
              <th scope="col">Dedication or notes</th>
              <th scope="col">
                <span className="sr-only">Actions</span>
              </th>
            </tr>
          </thead>

          <tbody>
            {songs.map((song,index)=><tr
              key={song.id}
              className={duplicateIds.has(song.id)
                ?'duplicate-song-row'
                :''
              }
            >
              <td className="song-number">
                {String(index+1).padStart(2,'0')}
              </td>

              <td data-label="Song title">
                <input
                  value={song.title}
                  onChange={(event)=>updateSong(
                    song.id,
                    'title',
                    event.target.value
                  )}
                  placeholder="Song title"
                  aria-label={`Song ${index+1} title`}
                />
              </td>

              <td data-label="Artist">
                <input
                  value={song.artist}
                  onChange={(event)=>updateSong(
                    song.id,
                    'artist',
                    event.target.value
                  )}
                  placeholder="Artist"
                  aria-label={`Song ${index+1} artist`}
                />
              </td>

              <td data-label="Priority">
                <select
                  value={song.priority}
                  onChange={(event)=>updateSong(
                    song.id,
                    'priority',
                    event.target.value
                  )}
                  aria-label={`Song ${index+1} priority`}
                >
                  {priorities.map((priority)=><option key={priority}>
                    {priority}
                  </option>)}
                </select>
              </td>

              <td data-label="Dedication or notes">
                <input
                  value={song.notes}
                  onChange={(event)=>updateSong(
                    song.id,
                    'notes',
                    event.target.value
                  )}
                  placeholder="Optional notes"
                  aria-label={`Song ${index+1} notes`}
                />
              </td>

              <td className="song-actions">
                <button
                  type="button"
                  className="icon-btn danger"
                  onClick={()=>removeSong(song.id)}
                  aria-label={`Remove song ${index+1}`}
                  title="Remove song"
                >
                  <SafeIcon icon={FiTrash2}/>
                </button>
              </td>
            </tr>)}
          </tbody>
        </table>
      </div>

      <button
        type="button"
        className="add-question music-add-song"
        onClick={addSong}
      >
        <SafeIcon icon={FiPlus}/>
        Add song request
      </button>
    </section>}

    {showPlaylistLinks&&<section>
      <div className="subsection-heading playlist-title">
        <span><SafeIcon icon={FiLink}/></span>
        <div>
          <h3>{playlistQuestion?.title||'Playlist links'}</h3>
          <p>YouTube,Spotify,or Apple Music links are welcome.</p>
        </div>
      </div>

      <div className="playlist-grid">
        {playlists.map((playlist,index)=><label key={playlist.category}>
          {playlist.category}
          <input
            value={playlist.url}
            onChange={(event)=>updatePlaylist(
              index,
              event.target.value
            )}
            placeholder="Paste playlist URL"
          />
        </label>)}
      </div>
    </section>}
  </div>;
}

export default MusicManager;